
<div class="row p-2 my-2" style="display: flex;justify-content: space-between;">

  <div *ngIf="showName" class="col-md-12 mat-body-1 displayFlex">
    <span [innerHTML]="question.safeHtmlContent"></span>
    <span style="margin-left: 8px;" *ngIf="question.questionToolTip">
      <img class="dupIcon-padd iconzoom cursor"
         matTooltip="{{question.questionToolTip}}"
         src="/assets/icons/information_tooltip.svg"
         alt="info icon"
         matTooltipClass="my-custom-tooltip"
         matTooltipPosition="above"/>
    </span>
  </div>
<!-- <div [ngClass]="{'col-md-6': showName}">s
  <div *ngIf="question.inputType === 'displaytext'" class="col-md-12">    
    <div [innerHTML]="question.questionText" ></div>
  </div>
</div> -->
</div>






